import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UIState {
  sidebarCollapsed: boolean;
  showSectionPropertiesPanel: boolean;
  currentDevice: "desktop" | "tablet" | "mobile";
  webbuilderPreviewMode: "live" | "preview";
  globalLoading: {
    isLoading: boolean;
    message?: string;
  };
  showFullscreenEditor?: boolean;
}

const initialState: UIState = {
  sidebarCollapsed: false,
  showSectionPropertiesPanel: false,
  currentDevice: "desktop",
  webbuilderPreviewMode: "live",
  globalLoading: {
    isLoading: false,
    message: undefined,
  },
  showFullscreenEditor: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
    },
    setShowSectionPropertiesPanel(state, action: PayloadAction<boolean>) {
      state.showSectionPropertiesPanel = action.payload;
    },
    setCurrentDevice(
      state,
      action: PayloadAction<"desktop" | "tablet" | "mobile">,
    ) {
      state.currentDevice = action.payload;
    },
    setWebbuilderPreviewMode(
      state,
      action: PayloadAction<"live" | "preview">,
    ) {
      state.webbuilderPreviewMode = action.payload;
    },
    setGlobalLoading(
      state,
      action: PayloadAction<{ isLoading: boolean; message?: string }>,
    ) {
      state.globalLoading.isLoading = action.payload.isLoading;
      state.globalLoading.message = action.payload.message;
    },
    setShowFullscreenEditor(state, action: PayloadAction<boolean>) {
      state.showFullscreenEditor = action.payload;
    },
    showGlobalLoading(state, action: PayloadAction<string | undefined>) {
      state.globalLoading.isLoading = true;
      state.globalLoading.message = action.payload;
    },
    hideGlobalLoading(state) {
      state.globalLoading.isLoading = false;
      state.globalLoading.message = undefined;
    },
    resetUI(state) {
      state.sidebarCollapsed = false;
      state.showSectionPropertiesPanel = false;
      state.currentDevice = "desktop";
      state.webbuilderPreviewMode = "live";
      state.globalLoading = {
        isLoading: false,
        message: undefined,
      };
    },
  },
});

export const {
  setSidebarCollapsed,
  setShowSectionPropertiesPanel,
  setCurrentDevice,
  setWebbuilderPreviewMode,
  setGlobalLoading,
  setShowFullscreenEditor,
  showGlobalLoading,
  hideGlobalLoading,
  resetUI,
} = uiSlice.actions;
export default uiSlice.reducer;
